import { _ as _asyncToGenerator, a as _regeneratorRuntime } from '../index-B0Q3DaKR.js';

var noop = function noop() {};
var asyncNoop = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function asyncNoop() {
    return _ref.apply(this, arguments);
  };
}();

export { asyncNoop, noop as default };
//# sourceMappingURL=index.js.map
